import {getHoursOfWalk, getSpeeds, displayTime} from "./test_map/speedHelper";
import generateGpx from "./test_map/generateGpx";

window.generateGpx = generateGpx

const noPoints = `
  <h3>${window.texts.title}</h3>
  
  <div class="temps-marche__info">
    <p class=""><strong><em>${window.location.host} </em></strong> ${window.texts.text1}</p>
    <p class="">${window.texts.text2}</p>
  </div>

 <p class="temps-marche__action">${window.texts.action1}</p>
 
 <div class="temps-marche__info">
 <p style="float: left"><a href="mailto:contact@temps-de-marche-montagne.fr">${window.texts.contact_cta}</a></p>
 <p style="float: right"><a href="https://apps.apple.com/fr/app/carte-de-randonn%C3%A9e-montagne/id6456126337">${window.texts.appli_iphone}</a></p>
 </div>
`

const onePoint = `
  <h3>${window.texts.title}</h3>

  <p class="temps-marche__action">${window.texts.instruction_1}</p>

  <button onclick="reset()">${window.texts.reinit}</button>
`

window.displayStats = function displayStats(result) {
  if (result.pointCount == 0) {
    document.getElementById('itinary_stats').innerHTML = noPoints
    return;
  }

  if (result.pointCount == 1) {
    document.getElementById('itinary_stats').innerHTML = onePoint
    return;
  }

  const {distance, altitudeProfile: {minAndMax, deniveles}, portions} = result

  const speeds = getSpeeds()

  const portionsContent = portions.map(
    ({distance: portionDistance, deniveles: portionDeniveles, minAndMax: portionMinAndMax}, index) => {
      return `
          <tr>
            <td>${(portionDistance / 1000).toFixed(2)} km</td>
            <td>${Math.round(portionDeniveles.up)} m</td>
            <td>${Math.round(portionDeniveles.down)} m</td>
            <td><strong>${displayTime(getHoursOfWalk(speeds, portionDistance, portionDeniveles.up, portionDeniveles.down))}</strong></td>
            <td>${portionMinAndMax.map((n) => n && n.toFixed()).join(', ')}</td>
          </tr>
        `
    }
  ).join('')

  const portionPartHtml = portions.length >= 2 ? `<h3>Les étapes: </h3>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>Distance</th>
                <th>Dénivelé montée</th>
                <th>Dénivelé descente</th>
                <th>Temps estimé</th>
                <th>Altitudes rencontrées</th>
              </tr>
            </thead>
            <tbody>${portionsContent}</tbody>
          </table>
        </div>` : ''

  const html = `
      <h3>Votre trajet</h3>
      <ul>
        <li>Distance: <strong>${(distance / 1000).toFixed(2)} km</strong></li>
        <li>Dénivelée montée: <strong>${Math.round(deniveles.up)} m</strong></li>
        <li>Dénivelée descente: <strong>${Math.round(deniveles.down)} m</strong></li>
        <li>Altitudes rencontrées: <strong>${minAndMax.map((n) => n.toFixed()).join(', ')}</strong></li>
        <li id="estimate_time_section">
            <strong>Temps estimé</strong>: <strong>${displayTime(getHoursOfWalk(speeds, distance, deniveles.up, deniveles.down))}</strong> 
            <small style="margin-left: 10px;">
                <a href="javascript:document.getElementById('estimate_time_section').classList.add('collapsed-mode')" class="default-not-collapsed">
                  Indiquer ma vitesse
                </a>
            </small>
            
            <form class="default-collapsed" onsubmit="window.updateSpeeds(this); return false">
                <div class="speed-config-values">
                 <label>Vitesse sur le plat:</label><div class="speed-config__number_and_unit"><input type="number" name="flat_speed" value="${speeds.flat}" step=".1" />km/h</div>
                 <label>Dénivelée montée par heure:</label><div class="speed-config__number_and_unit"><input type="number" name="up_speed" value="${speeds.up}" />m montés / h</div>
                 <label>Dénivelée descendue par heure:</label><div class="speed-config__number_and_unit"><input type="number" name="down_speed" value="${speeds.down}" />m descendus / h</div>
                </div> 
             
               <div class="speed-config__submit-container"><input type="submit"  value="Mettre à jour" style="" /></div>
            </form>
          </li>
      </ul>
      
      ${portionPartHtml}
      
      <p><a href="javascript:generateGpx()">Exporter au format GPX</a></p>
      
      <button onclick="reset()">Réinitialiser</button>
      
      <p class="temps-marche__action">Vous pouvez ajouter d'autres étapes en cliquant sur la carte</p>
      
      <div>
      <small>
      <em>
      <p>Le trajet et l'ensemble des informations sont donnés à titre indicatif uniquement et peuvent être inexacts. Il peut notamment exister des itinéraires plus long en distance mais plus rapide que celui indiqué.</p>
      <p>
      Les chemins indiqués peuvent ne pas/plus exister. Il convient de se renseigner en amont et de suivre les règles de prudence en montagne.  <strong>${window.location.host}</strong> décline toute responsabilité envers d'éventuels problèmes survenant pendant le trajet.
      </p>
      </em>
</small>
</div>
    `;

  document.getElementById('itinary_stats').innerHTML = html
}
